import { first } from 'rxjs/operators';
import { ActivityService, Activity } from '@app/_components/activity';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityComponent } from '../activity/activity.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
    selector: 'app-activity-list',
    templateUrl: './activity-list.component.html',
    styleUrls: ['./activity-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ActivityListComponent implements OnInit {
	constructor(
		private activityService: ActivityService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private router: Router
	) {
		this.statuses = activityService.statuses
	}



	// data
	@Input() activityProviderId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Output() closeDialog = new EventEmitter<any>();

	activities: any;
	activity: Activity;


	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'activityType', header: 'Activity Type', width: 'auto' },
		{ field: 'invoiceType', header: 'Invoice Type', width: 'auto' },
		{ field: 'activityProviderId', header: 'Activity ProviderId', width: 'auto' },
	];

	ngOnInit(): void {
		console.log("activityProviderId : " + this.activityProviderId);
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.activityId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-activity-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if (this.activityProviderId) {
				// show only activities that are assigned to this activityProviderId
				let activityProviderIdFilter = { 'activityProviderId': { 'value': this.activityProviderId, 'matchMode': 'in' } };
				Object.assign(event.filters, activityProviderIdFilter);
			}


			const pageNumber = Math.round(event.first / event.rows);
			this.activityService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.activities = res.data.activitys;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.activities = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		//this.onOpenFormEdit(event.data);
		this.router.navigate(['activity-edit', event.data.activityId]);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(activity: Activity) {
		try {
			this.formLoading = true;
			this.activityService.update(activity)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.activities.map((activity, i) => {
							if (activity.activityId === res.data.activity.activityId) {
								this.activities[i] = res.data.activity;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(activity: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(activity));

			this.formLoading = true;
			this.activityService.delete(activity.activityId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.activities.splice(this.activities.indexOf(activity), 1);
						this.recordTotal = this.activities.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Activity ' + activity.activityId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Activity ' + activity.activityId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Activity',
			activityProviderId: this.activityProviderId

		};
		this.closeDialog.emit("");
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addActivityCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	onOpenFormAdd1() {


		// pass data, ie rateBuicket: this.shortTermRentalId,
		const dataConfig = {
			title: 'Add Activity',
			activityProviderId: this.activityProviderId

		};
		this.router.navigate(['activity-add'], { state: dataConfig });
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(activity: Activity) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			activity: activity,
			activityProviderId: this.activityProviderId,
			title: 'Edit Activity'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateActivityCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteActivityCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	onOpenFormEdit1(activity: Activity) {

		const dataConfig = {
			activity: activity,
			activityProviderId: this.activityProviderId,
			title: 'Edit Activity'
		};

		this.router.navigate(['activity-edit'], { state: dataConfig });
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addActivityCB(activity: Activity) {
		console.log('Adding Activity: ' + JSON.stringify(activity));
		// if we don't have a activities array yet...
		if (!this.activities) {
			this.activities = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.activities.unshift(activity);

		// no idea what this is but it is required to update the array
		this.activities = [...this.activities];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Activity ' + activity.activityId + ' Added', life: 3000 });
	}

	updateActivityCB(activity: Activity) {
		console.log('Updating Activity: ' + JSON.stringify(activity));
		let itemIndex = this.activities.findIndex((item: any) => item.activityId === activity.activityId);
		this.activities[itemIndex] = activity;

		// no idea what this is but it is required to update the array
		this.activities = [...this.activities];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Activity ' + activity.activityId + ' Updated', life: 3000 });
	}

	deleteActivityCB(activity: Activity) {
		console.log('Removing Activity: ' + activity);
		this.activities.splice(this.activities.indexOf(activity), 1);
		this.recordTotal = this.activities.length;

		// no idea what this is but it is required to update the array
		this.activities = [...this.activities];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Activity ' + activity.activityId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.activities ? this.first === (this.activities.length - this.rows) : true; }
	isFirstPage(): boolean { return this.activities ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(activity: any) {
		if (activity?.status) {
			const status = this.statuses.find((e: any) => e.value == activity.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}
}
